import classNames from "classnames";

interface ProgressBarProps {
    value?: number;
    max?: number;
    className?: string;
    text?: string; // Unit shown next to the numbers
    nums?: boolean; // Show current value and maximum inside the bar
    stroke?: number; // Thickness: height in rem is stroke / 4
}

const ProgressBar = ({
                         value = 0,
                         max = 100,
                         className,
                         text = "",
                         nums = false,
                         stroke = 4
                     }: ProgressBarProps) => {
    // Guards against bad API data: negative, NaN, zero max, value above max
    const safeMax = Math.max(Number(max) || 0, 1);
    const safeValue = Math.min(Math.max(Number(value) || 0, 0), safeMax);

    const progress = (safeValue / safeMax) * 100;
    const height = Math.max(stroke / 4, 0.5);

    return (
        <div
            role="progressbar"
            aria-valuenow={safeValue}
            aria-valuemin={0}
            aria-valuemax={safeMax}
            className={classNames(
                "relative w-full overflow-hidden rounded-full bg-gray-100 border border-gray-200",
                className
            )}
            style={{ height: `${height}rem` }}
        >
            {/* Fill starts on the reading side: right in Persian, left in English */}
            <div
                className="absolute top-0 start-0 h-full rounded-full bg-blue-600 transition-all duration-500 ease-out"
                style={{ width: `${progress}%` }}
            />

            {nums && (
                <>
                    <span className="absolute inset-y-0 start-3 z-10 flex items-center text-xs font-bold text-white whitespace-nowrap">
                        {safeValue}
                        {text && ` ${text}`}
                    </span>

                    {/* The maximum would sit on top of the fill, so it only shows when there's room */}
                    {progress < 50 && (
                        <span className="absolute inset-y-0 end-3 z-10 flex items-center text-xs font-semibold text-gray-600 whitespace-nowrap">
                            {safeMax}
                            {text && ` ${text}`}
                        </span>
                    )}
                </>
            )}
        </div>
    );
};

export default ProgressBar;